var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_has.js
// module id = 32
// module chunks = 2